var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"200px","height":"200px"},attrs:{"id":'svgaBox'+_vm.cid}})])
}
var staticRenderFns = []

export { render, staticRenderFns }